import { NewPasswordPage, requireGuest } from "@/features/auth";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/new-password")({
  beforeLoad: requireGuest,
  component: NewPasswordPage,
});
